<template>
  <div >
     	<van-field
        :required="true"
        v-model="dqAddress"
        :readonly="true"
        label="现居住地"
        placeholder="请选择"
        input-align="right"
        right-icon="arrow"
        @click="clickJzd"
      />
     <van-popup v-model="show1" position="bottom" :style="{ height: '80%' }">
    <div class="u-content-wrap" style="padding-top:12px">
      <van-empty v-if="list.length == 0" style="width: 100%" description="暂无地址信息" />
      <div v-if="list.length > 0">
        <van-radio-group v-model="dqjzd">
          <div class="card" v-for="(item, index) in list" :key="index">
            <div class="card-top">
              <span class="address">{{ item }}</span>
              <van-icon name="edit" color="#999" :size="20" @click="clickEdit(index)" />
            </div>
            <div class="card-bottom">
              <van-radio :name="index">默认地址</van-radio>
              <div class="delete" @click="clickDelete(index)">删除</div>
            </div>
          </div>
        </van-radio-group>
      </div>
    </div>
    <div class="btn">
      <van-button type="info" style="width: 40%" @click="clickAdd">新增地址</van-button>
      <van-button type="info" style="width: 40%" @click="clickSumbit">保存</van-button>
    </div>
     </van-popup>
    <!-- <van-popup v-model="show" round position="bottom" :style="{ height: '30%' }" /> -->
    <van-popup v-model="show" position="bottom" :style="{ height: '50%' }">
      <van-form>
        <van-field :required="true" v-model="address" label="地址" placeholder="请输入地址" input-align="right" />

        <van-field label="设置默认地址" input-align="right">
          <template #input>
            <van-switch v-model="sfmrdz" size="20" />
          </template>
        </van-field>
      </van-form>

      <div class="b-btn" style="margin-top: 50px">
        <button class="b-button" :disabled="disabled" @click="clickSave">确定</button>
      </div>
    </van-popup>
  </div>
</template>

<script>

export default {
    props: {
    defJzd: {
      type: [String,Number],
      default: '',
    },
    defDqjzd:{
      type: [String,Number],
      default:-1,
    }
 
  },
  data() {
    return {
      list: [],
      jzd: '',
      dqjzd: -1,
      current: 0,
      show: false,
      sfmrdz: false,
      address: '',
      type: '',
      show1:false,
      dqAddress:'',
    }
  },
  created() {
  
  },
   watch: {
    defJzd: {
      immediate: true,
      handler() {
        if(this.defJzd){
          this.list = this.defJzd.split(',')
        this.dqAddress = this.list[this.defDqjzd];
        }
       
      },
    },
     defDqjzd: {
      immediate: true,
      handler() {
        this.dqjzd = Number(this.defDqjzd)
      },
    },
  },
  computed: {
    disabled() {
      let validate = true
      if (this.address) {
        validate = false
      }
      return validate
    },
  },
  methods: {
    clickAdd() {
      this.type = '02'
      this.address = ''
      this.sfmrdz = false
      this.show = true
    },
    clickEdit(index) {
      this.type = '01'
      let address = this.list[index]
      let sfmrdz = this.dqjzd == index
      this.current = index
      this.address = address
      this.sfmrdz = sfmrdz
      this.show = true
    },
    clickDelete(index) {
      if (index == this.dqjzd) {
        //默认地址
        this.dqjzd = -1
      } else if (index < this.dqjzd) {
        //
        this.dqjzd = this.dqjzd - 1
      } else {
      }
      this.list.splice(index, 1);
      this.dqAddress = '';
      this.$emit('deleteAddress');
    },
    clickSumbit() {
      if (this.dqjzd == -1) {
        return this.$toast('请选择默认地址')
      }
      this.dqAddress = this.list[this.dqjzd];
      let data = {jzd:this.list.join(','),dqjzd:this.dqjzd}
      this.$emit('config',data);
      this.show1 =false;
    },
    clickSave() {
      if (this.type == '01') {
        //编辑
        if (this.sfmrdz) {
          this.dqjzd = this.current
        }
        this.$set(this.list, this.current, this.address)
      } else if (this.type == '02') {
        //新增
        this.list.push(this.address)
        if (this.sfmrdz) {
          this.dqjzd = this.list.length - 1
        }
      }
      this.show = false
    },
    clickJzd(){
      this.show1 = true;
    }
  },
 
}
</script>

<style lang="less" scoped>
.u-wrap {
  height: 100vh;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  padding-top: 12px;
  background-color: #f5f5f5;
}
.heard {
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100%;
  z-index: 1;
}
.u-content-wrap {
  flex: 1;
  display: flex;
}

.card {
  background: #fff;
  border-radius: 5px;
  padding: 10px;
  margin-bottom: 10px;
  box-shadow: 0px 1px 8px 0 rgba(0, 0, 0, 0.08);
  position: relative;
  overflow: hidden;
  width: 90vw;
  margin-left: 2vw;

  .card-top {
    display: flex;
    align-items: center;

    .address {
      flex: 1;
      line-height: 40px;
      margin-right: 10px;
      font-size: 15px;
    }
  }

  .card-bottom {
    border-top: 1px solid #dedede;
    display: flex;
    justify-content: space-between;
    padding-top: 6px;
    font-size: 14px;

    .delete {
      color: #696969;
    }
  }
}

.btn {
  padding: 20px;
  display: flex;
  justify-content: space-around;
}

.b-btn {
  padding: 0 20px;

  .b-button {
    width: 100%;
    height: 44px;
    background: #3f8ffb;
    border-radius: 5px;
    opacity: 1;
    border: none;
    color: #ffffff;
  }

  .b-button[disabled] {
    opacity: 0.48;
  }
}
</style>
